import { createSvgIcon } from "@mui/material/utils";

/**
 * Upload icon.
 *
 * ![UploadIcon](data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSItMi40IC0yLjQgMjQuOCAyNC44IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0MCIgaGVpZ2h0PSI0MCIgc3R5bGU9ImJhY2tncm91bmQ6I2ZmZjtib3JkZXItcmFkaXVzOjRweCI+PHBhdGggZD0iTTYuNjY2MDIgMTMuMzMzM0w5Ljk5OTM1IDEwTTkuOTk5MzUgMTBMMTMuMzMyNyAxMy4zMzMzTTkuOTk5MzUgMTBWMTcuNU0xNi42NjYgMTMuOTUyNEMxNy42ODM5IDEzLjExMTcgMTguMzMyNyAxMS44Mzk5IDE4LjMzMjcgMTAuNDE2N0MxOC4zMzI3IDcuODg1MzYgMTYuMjgwNyA1LjgzMzMzIDEzLjc0OTMgNS44MzMzM0MxMy41NjczIDUuODMzMzMgMTMuMzk2OSA1LjczODMzIDEzLjMwNDQgNS41ODE0NUMxMi4yMTc3IDMuNzM3MzYgMTAuMjExNCAyLjUgNy45MTYwMiAyLjVDNC40NjQyNCAyLjUgMS42NjYwMiA1LjI5ODIyIDEuNjY2MDIgOC43NUMxLjY2NjAyIDEwLjQ3MTggMi4zNjIyMiAxMi4wMzA5IDMuNDg4NDcgMTMuMTYxMyIgc3Ryb2tlPSIjNDc1NDY3IiBzdHJva2Utd2lkdGg9IjEuNjY2NjciIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCI+PC9wYXRoPjwvc3ZnPg==)
 */
const UploadIcon = createSvgIcon(
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.66602 13.3333L9.99935 10M9.99935 10L13.3327 13.3333M9.99935 10V17.5M16.666 13.9524C17.6839 13.1117 18.3327 11.8399 18.3327 10.4167C18.3327 7.88536 16.2807 5.83333 13.7493 5.83333C13.5673 5.83333 13.3969 5.73833 13.3044 5.58145C12.2177 3.73736 10.2114 2.5 7.91602 2.5C4.46424 2.5 1.66602 5.29822 1.66602 8.75C1.66602 10.4718 2.36222 12.0309 3.48847 13.1613"
      stroke="#475467"
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>,
  "Upload"
);

export default UploadIcon;
